import React, { createContext, useContext, useState, useEffect } from "react";
const CryptoJS = require("crypto-js");

type DiscountData = {
    couponCode: string;
    couponValue: number;
    paymentDiscountCode: string;
    paymentDiscountTypeValue: number;
    paymentDiscountValue: number;
};

type DiscountContextType = {
    data: DiscountData;
    finishData: DiscountData;
    setCoupon: (code: string, value: number) => void;
    setPaymentDiscount: (code: string, value: number, value2: number) => void;
    clearDiscounts: () => void;
};

const initialData: DiscountData = {
    couponCode: "",
    couponValue: 0,
    paymentDiscountCode: "",
    paymentDiscountTypeValue: 0,
    paymentDiscountValue: 0,
};

const finishedData: DiscountData = {
    couponCode: "",
    couponValue: 0,
    paymentDiscountCode: "",
    paymentDiscountTypeValue: 0,
    paymentDiscountValue: 0,
};

const STORAGE_KEY = "discountData";
const STORAGE_KEY_FINISHED = "discountFinishedData";
const SECRET = !process.env.REACT_APP_JWT_SALT ? "ninegridCrypoToken" : process.env.REACT_APP_JWT_SALT



export const DiscountContext = createContext<DiscountContextType | undefined>(undefined);

export const DiscountProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [data, setData] = useState<DiscountData>(initialData);
    const [finishData, setFinishData] = useState<DiscountData>(finishedData);

    // Carrega do localStorage ao iniciar
    useEffect(() => {
        const encrypted = localStorage.getItem(STORAGE_KEY);
        if (encrypted) {
            try {
                const bytes = CryptoJS.AES.decrypt(encrypted, SECRET);
                const decrypted = bytes.toString(CryptoJS.enc.Utf8);
                if (decrypted) setData(JSON.parse(decrypted));
            } catch {
                setData(initialData);
            }
        }
        const encrypted2 = localStorage.getItem(STORAGE_KEY_FINISHED);
        if (encrypted2) {
            try {
                const bytes = CryptoJS.AES.decrypt(encrypted2, SECRET);
                const decrypted = bytes.toString(CryptoJS.enc.Utf8);
                if (decrypted) setFinishData(JSON.parse(decrypted));
            } catch {
                setData(initialData);
            }
        }

    }, []);

    // Salva no localStorage sempre que mudar
    useEffect(() => {
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET).toString();
        localStorage.setItem(STORAGE_KEY, encrypted);
    }, [data]);

    useEffect(() => {
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(finishData), SECRET).toString();
        localStorage.setItem(STORAGE_KEY_FINISHED, encrypted);
    }, [finishData]);

    const setCoupon = (code: string, value: number) => {
        setData((prev) => ({ ...prev, couponCode: code, couponValue: value }));
    };

    const setPaymentDiscount = (code: string, discountValue: number, discountTypeValue: number) => {
        setData((prev) => ({ ...prev, paymentDiscountCode: code, paymentDiscountValue: discountValue, paymentDiscountTypeValue: discountTypeValue }));
    };

    const clearDiscounts = () => {
        setFinishData(data)
        setData(initialData);
        localStorage.removeItem(STORAGE_KEY);
    };

    return (
        <DiscountContext.Provider value={{ data, setCoupon, setPaymentDiscount, clearDiscounts ,finishData}}>
            {children}
        </DiscountContext.Provider>
    );
};

